export const defaults = Object.freeze({
  editWindow: 8,
});
